import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  job: {},
  results: [],
  total: 0,
  terms: '',
  sort: [{'title.raw': {order: 'asc'}}],
  from: 0,
  size: 10,
  pageNumber: 1,
  aggregations: {},
  libraryPositionMapping: {},
  selectedFacets: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/job/vuex/index.js